import React from "react";
import {
  ShapeContainer,
  ShapeBox,
  ShapeWrapper,
  ShapeImgWrapper,
} from "./index.styled";
import keyboard from "assets/images/keyboard.svg";
import headphone from "assets/images/headphone-login.svg";
import audio from "assets/images/audio.svg";
import microphone from "assets/images/microphone.svg";

const AuthShapes = ({ width, height, backGroundColor, border }) => {
  return (
    <ShapeContainer>
      <ShapeWrapper>
        <ShapeBox
          width="197px"
          backGroundColor="#D1E6FF"
          borderTopRightRadius="106px"
          height="197px"
          className="marginRight"
        ></ShapeBox>
        <ShapeBox
          width="197px"
          backGroundColor="#F0F7FF"
          borderBottomLeftRadius="98px"
          height="196px"
          className="marginRight"
        ></ShapeBox>
        <ShapeBox
          width="197px"
          backGroundColor="#FFFFFF"
          borderTopLeftRadius="105px"
          border="2px dashed #9DC9FF"
          height="196px"
          className="marginRight"
        >
          <ShapeBox
            width="174px"
            backGroundColor="#F0F7FF"
            borderTopLeftRadius="106px"
            height="173px"
          >
            <ShapeImgWrapper>
              <div>
                <img src={audio} alt="audio" />
              </div>
              <div>
                <img src={microphone} alt="microphone" />
              </div>
            </ShapeImgWrapper>
          </ShapeBox>
        </ShapeBox>
      </ShapeWrapper>
      <ShapeWrapper>
        <ShapeBox
          width="269px"
          backGroundColor="#FFFFFF"
          height="197px"
          borderTopLeftRadius="106px"
          borderBottomRightRadius="106px"
          border="2px dashed #9DC9FF"
          className="marginRight"
        >
          <ShapeBox
            width="237px"
            backGroundColor="#F0F7FF"
            borderTopLeftRadius="106px"
            borderBottomRightRadius="106px"
            height="172px"
          >
            <img src={keyboard} alt="keyboard" />
          </ShapeBox>
        </ShapeBox>
        <ShapeBox
          width="138px"
          backGroundColor="#F0F7FF"
          height="197px"
          borderTopRightRadius="127px"
          borderBottomRightRadius="127px"
          className="marginRight"
        ></ShapeBox>
        <ShapeBox
          width="181px"
          backGroundColor="#D1E6FF"
          height="196px"
          borderTopRightRadius="98px"
          className="marginRight"
        ></ShapeBox>
      </ShapeWrapper>
      <ShapeWrapper>
        <ShapeBox
          width="138px"
          backGroundColor="#F0F7FF"
          height="197px"
          borderBottomRightRadius="71px"
          className="marginRight"
        ></ShapeBox>
        <ShapeBox
          width="183px"
          backGroundColor="#D1E6FF"
          height="196px"
          borderTopLeftRadius="119px"
          className="marginRight"
        ></ShapeBox>
        <ShapeBox
          width="268px"
          backGroundColor="#FFFFFF"
          height="197px"
          borderTopLeftRadius="138px"
          borderBottomLeftRadius="138px"
          border="2px dashed #BBDAFF"
          className="marginRight"
        >
          <ShapeBox
            width="243px"
            backGroundColor="#F0F7FF"
            height="171px"
            borderTopLeftRadius="138px"
            borderBottomLeftRadius="138px"
          >
            <img src={headphone} alt="headphone" />
          </ShapeBox>
        </ShapeBox>
      </ShapeWrapper>
    </ShapeContainer>
  );
};

export default AuthShapes;
